import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import ConstructorRecsActions from 'actions/ConstructorRecsActions';
import ConstructorRecsSelector from 'selectors/constructorRecs/constructorRecsSelector';
import { CONSTRUCTOR_PODS } from 'constants/constructorConstants';

const { wrapHOC } = FrameworkUtils;
const { constructorRecsSelector } = ConstructorRecsSelector;
const { updateRequestData } = ConstructorRecsActions;
const fields = createSelector(constructorRecsSelector, constructorRecs => {
    const currentRecs = constructorRecs[CONSTRUCTOR_PODS.FREQUENTLY_BOUGHT_TOGETHER];
    let recs = [];
    let title = '';

    if (!currentRecs?.isError && !currentRecs?.isEmpty) {
        recs = currentRecs?.constructorRecommendations || [];
        title = currentRecs?.constructorTitle || '';
    }

    return { recs, title };
});

const functions = { updateRequestData };
const withFrequentlyBoughtTogetherProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withFrequentlyBoughtTogetherProps
};
